
import axios from 'axios'

// state
export const state = {
    teste: {},
    categorias: [],
    assuntos: []
}

// actions
export const actions = {

  setTeste ({ commit, dispatch }, id){
    commit('SET_TESTE', { teste : {} })
    try{
        const { data } = axios.get('/api/testes-json/'+ id)
        commit('SET_TESTE', { teste : data })
    } catch (e) {
        dispatch('alert/erroAoCarregar', null ,{ root: true })
     }
  },

  getCategorias({ commit, dispatch }){
        try{
            let categorias = (axios.get('/api/teste-categs-json')).data
            commit('SET_TESTE_CATEGS', { categorias })
            let assuntos = (axios.get('/api/teste-assuntos-json')).data
            commit('SET_TESTE_ASSUNTOS', { assuntos })
        } catch (e) {
            dispatch('alert/erroAoCarregar', null ,{ root: true })
        }
  }

}

// mutations
export const mutations = {

  SET_TESTE (state, {teste}){
    state.teste = teste
  },

  SET_TESTE_CATEGS (state, {categorias}){
    state.categorias = categorias
  },

  SET_TESTE_ASSUNTOS (state, {assuntos}){
    state.assuntos = assuntos
  }

}

export default {
  state,
  actions,
  mutations
}
